import { AsyncPipe, SlicePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  output,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'trim-text',
  templateUrl: './trim-text.component.html',
  styleUrls: ['./trim-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TooltipModule, AsyncPipe, SlicePipe],
})
export class TrimTextComponent implements OnInit {
  private router = inject(Router);

  columnData: Observable<any> = new BehaviorSubject(null);
  keyName!: string;
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output();
  value!: number;
  ngOnInit(): void {}

  onGoToRoute(url: string, id: number) {
    this.router.navigate([url, id]);
  }
}
